export default {"src":"/_next/static/media/property-news-map-icon.53a4a60e.svg","height":115,"width":100,"blurWidth":0,"blurHeight":0};